var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ee-checkbox",
    class: {
      'is-checked': _vm.checked
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "ee-checkbox__icon"
  }), _vm._v(" "), _vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d6b3516","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/checkbox/Checkbox.vue
// module id = 568
// module chunks = 13